// @param {Object} event
// @param {string} event.title
// @param {ISOString-ish date: yyyymmddThhmmss} event.start
// @param {ISOString-ish date: yyyymmddThhmmss} event.end
// @param {number} event.length in minutes
// @param {string} event.address
// (optional) @param {string} event.description

export function google(event, timezone) {
  return encodeURI([
    'https://www.google.com/calendar/render',
    '?action=TEMPLATE',
    `&text=${event.title || ''}`,
    `&dates=${event.start || ''}`,
    `/${event.end || ''}`,
    `&details=${event.description || ''}`,
    `&location=${event.address || ''}`,
    '&sprop=&sprop=name:',
    `&ctz=${timezone}`,
  ].join(''));
}

export function ics(event, timezone) {
  return encodeURI(
    `data:text/calendar;charset=utf8,${[
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'BEGIN:VEVENT',
      `DTSTART;TZID=${timezone}:${event.start || ''}`,
      `DTEND;TZID=${timezone}:${event.end || ''}`,
      `SUMMARY:${event.title || ''}`,
      `DESCRIPTION:${event.description || ''}`,
      `LOCATION:${event.address || ''}`,
      'END:VEVENT',
      'END:VCALENDAR'].join('\n')}`);
}



// WEBPACK FOOTER //
// ./src/helpers/addToCalendar.js